<div class="sh-action-bar-wrapper -sh-dark" [ngClass]="{'-sh-overlay': overlay}">
    <div class="sh-action-bar -sh-on-dark">
        <div class="sh-action-bar__group">
            <div class="sh-action-bar__group__item">
                <sh-action-mode-checkbox
                    [canBatchSelect]="canBatchSelect"
                    [itemsSelectedLabelKey]="itemsSelectedLabelKey"
                    [noItemsSelectedLabelKey]="noItemsSelectedLabelKey"
                    [totalPageItemsCount]="totalPageItemsCount"
                    [selectedPageItemsCount]="selectedPageItemsCount"
                    [selectedItemsCount]="selectedItemsCount"
                    [isInitialBulk]="isInitialBulk"
                    (selectionChanged)="onSelectionChanged($event)"
                >
                </sh-action-mode-checkbox>
            </div>
        </div>
        <div class="sh-action-bar_group">
            <sh-action-group class="sh-action-bar__group__item" [actionGroup]="actionGroup$ | async"></sh-action-group>
        </div>
    </div>
</div>
